import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { BORDER_RADIUS_SIZES } from '../table-row/constants';

import type { TTableHeader } from './models';

export const TableHeader: FC<TTableHeader> = ({
    borderRadius = 24,
    children,
    sticky = false,
    styles,
}) => (
    <thead
        className={cn(
            { [styles.stickyTableHeader]: sticky },
            styles[`headerBorderRadius${BORDER_RADIUS_SIZES[borderRadius]}`]
        )}
    >
        {children}
    </thead>
);
